import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UserSmallAvatar from '../../components/User/UserSmallAvatar';
import { getRandomColors } from '../../utils/helpers';

export default class TopicListItemUserList extends Component {
  static propTypes = {
    users: PropTypes.array.isRequired,
    topicCreator: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);

    this.usersToRender = 4;
    this.colors = getRandomColors(this.usersToRender);

    this.state = {
      colors: []
    };
  }

  render() {
    const { users, topicCreator } = this.props;
    return (
      <div className="themes-list__item themes-list__item--users -mobile-hide">
        <div className="themes-list__user-list">
          {users.length ? (
            <TopicListItemUserListContent
              users={users}
              colors={this.colors}
              usersToRender={this.usersToRender}
            />
          ) : (
            <React.Fragment />
          )}
        </div>
      </div>
    );
  }
}

function TopicListItemUserListContent(props) {
  const usersToRender = props.usersToRender;
  const users = props.users;
  const colors = props.colors;

  {
    /* если юзеров больше чем нужно, то взять для показа (нужное_колличество - 1)
          и добавить в конце серый аватар "и другие..." */
  }

  return users.length < usersToRender
    ? users.map((user, idx) => <UserSmallAvatar key={idx} color={colors[idx]} user={user} />)
    : users.slice(0, usersToRender).map((user, idx) => (idx < usersToRender - 1 ? (
      <UserSmallAvatar color={colors[idx]} user={user} />
    ) : (
      <div className="themes-list__user themes-list__user--more">
        <div className="themes-list__user-avatar themes-list__user-avatar--no-image">•••</div>
        <span className="themes-list__user-name button__hint">И другие...</span>
      </div>
    )));
}
